import React from 'react';

const UNoDataFound = (props) => {
    return (
        <React.Fragment>
            <div className={`u_errorpage ${props?.className}`}>
                <div className="u_errorpage-image">
                    <img src={props?.image} alt={props?.message} style={{width: `${props.width}px`, height: `${props.height}px`}} />
                    <h2>{props?.message || 'No data to display'}</h2>
                    {props?.description && <p>{props?.description}</p>}
                    {props.button}
                </div>
            </div>
        </React.Fragment>
    );
};

export default UNoDataFound;
